<h1 mat-dialog-title>{{data.title}}</h1>
<div mat-dialog-content>
  <p>
    {{ data.message }} {{data.showTimeRemaining ? ((this.timeRemaining | async) + ' seconds') : '' }}
  </p>
</div>
<div mat-dialog-actions align="center">
  <button
    mat-button
    [mat-dialog-close]="true"
    cdkFocusInitial
    (click)="onDialogClose()"
  >
    {{data.btnOk}}
  </button>
  <button
    mat-button
    color="warn"
    *ngIf="data.btnCancel"
    (click)="logout()"
    (click)="onDialogClose()"
  >
    {{data.btnCancel}}
  </button>
</div>
